import { PipeTransform, Pipe, inject } from "@angular/core";
import { Category } from "src/app/routes/catalog/models/category.model";
import { Product } from "src/app/routes/catalog/models/product.model";
import { Page } from "../models/page.model";
import { UrlService } from "../services/url.service";

@Pipe({ name: "url" })
export class UrlPipe implements PipeTransform {
  private urlService = inject(UrlService);

  transform(item: Category | Product | Page, format?: string) {
    return this.urlService.get(item, format === "full");
  }
}
